export const socialsData = {
    github: 'https://github.com/aidanarmstrong',
    linkedIn: 'https://www.linkedin.com/in/aidanarmstrong',
    instagram: 'https://www.instagram.com/aidanjarmstrong',
    twitter: 'https://twitter.com/aidanjarmstrong',
    gitlab: 'https://gitlab.com/aidanarmstrong',
    mail: "aidanarmstrong4@gmail.com"
}